import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaMoneyBillWave } from "react-icons/fa";
import axios from "axios";
import useAuth from "../dashboard/useAuth";
import Sidebar from "../dashboard/sidebar";
import Navbar from "../dashboard/navbar";

const Ventes = ({ titre }) => {
    useAuth();
    const [ventes, setVentes] = useState([]);
    const [selectedVente, setSelectedVente] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: "date_vente", direction: "descending" });
    const [searchTerm, setSearchTerm] = useState("");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [totalCA, setTotalCA] = useState(0);
    const user_id = localStorage.getItem("IDDDD");
    const [filtreStatutAchat, setFiltreStatutAchat] = useState('Tout');

    useEffect(() => {
        if (user_id) {
            document.title = "PayMe | Suivi des ventes";
            verifGroupe();
            fetchVentes();
        }
    }, [user_id, startDate, endDate]);

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 3000);
    };


    const fetchVentes = async () => {
        try {
            let url = `${process.env.REACT_APP_HOTE}/suivi-ventes-utilisateur/${user_id}/`;

            const params = new URLSearchParams();
            if (startDate) params.append('start_date', startDate);
            if (endDate) params.append('end_date', endDate);

            if (params.toString()) {
                url += `?${params.toString()}`;
            }

            const response = await axios.get(url);
            console.log("Réponse complète:", response);

            setVentes(response.data.ventes || []);
            setTotalCA(response.data.total_ca || 0);

        } catch (error) {
            console.error("Erreur détaillée:", error.response?.data || error.message);
            showAlert(error.response?.data?.message || "Erreur serveur", "danger");
            setVentes([]);
            setTotalCA(0);
        }
    };


    // Ajoutez une fonction pour calculer le CA des ventes filtrées (client-side)
    const calculateFilteredCA = () => {
        return filteredVentes.reduce((sum, vente) => sum + vente.total, 0);
    };



    const verifGroupe = async () => {
        const groupe = localStorage.getItem("groupe");
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
            if (response.status === 200) {
                const cleanedAccessArray = response.data.acces
                    .map(item => item.acces ? item.acces.replace(/[\[\]']/g, "").trim().split(",").map(access => access.trim()) : [])
                    .flat();
                setAccesGroupe(cleanedAccessArray);
                localStorage.setItem("accesGroupe", JSON.stringify(cleanedAccessArray));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe', error);
        }
    };

    // if (!accesGroupe.includes("Produits")) {
    //     return null;
    // }

    const handleResetDates = () => {
        setStartDate("");
        setEndDate("");
    };



    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

   const filteredVentes = ventes.filter(vente => {
    const matchesSearch =
        vente.client?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        vente.produit?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        vente.transaction_id?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus = filtreStatutAchat === "Tout" || 
                         (filtreStatutAchat === "Acheté" && vente.statut === "Acheté") ||
                         (filtreStatutAchat === "Espèce" && vente.statut === "Espèce") ||
                         (filtreStatutAchat === "Précommandé" && vente.statut === "Précommandé");

    return matchesSearch && matchesStatus;
});


    const sortedVentes = [...filteredVentes].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const indexOfLastVente = currentPage * itemsPerPage;
    const indexOfFirstVente = indexOfLastVente - itemsPerPage;
    const currentVentes = sortedVentes.slice(indexOfFirstVente, indexOfLastVente);
    const totalPages = Math.ceil(sortedVentes.length / itemsPerPage);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex align-items-center">
                            <img
                                src="/assets/images/vente.png"
                                alt="Suivi des ventes"
                                style={{ width: '25px', height: '25px', marginRight: '10px' }}
                            />
                            Suivi des ventes
                        </h2>
                        <small>Suivi des ventes.</small>
                        <small id="hbreadcrumb" className="d-flex justify-content-end">
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    {/* Utiliser Link de react-router-dom pour la navigation */}
                                    <Link to={`/boutique`}> Ma boutique</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    {/* Utiliser Link de react-router-dom pour la navigation */}
                                    Suivi des ventes
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>

                <div className="mt-3">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                        <h5>Historique des ventes</h5>
                        <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: "10px" }}>
                            <div className="d-flex">
                                {(startDate || endDate) && (
                                    <button
                                        className="btn btn-secondary mr-2"
                                        onClick={handleResetDates}
                                    >
                                        Réinitialiser
                                    </button>
                                )}
                                <button className="btn btn-success mr-2">
                                    <FaPlus /> Exporter
                                </button>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                    )}


                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>
                                        </div>
                                        <select
                                            className="form-select bg-default p-1"
                                            style={{
                                                width: "auto",
                                                border: "1px black solid",
                                                borderRadius: "5px",
                                            }}
                                            value={filtreStatutAchat}
                                            onChange={(e) => {
                                                setFiltreStatutAchat(e.target.value);
                                                setCurrentPage(1); // Réinitialiser à la première page lors du changement de filtre
                                            }}
                                        >
                                            <option value="Tout">Tout</option>
                                            <option value="Acheté">Acheté</option>
                                            <option value="Espèce">Espèce</option>
                                            <option value="Précommandé">Précommandé</option>
                                        </select>

                                        {/* Bloc dates centré */}
                                        <div className="d-flex justify-content-center flex-grow-1">
                                            <div className="d-flex " style={{ gap: "10px" }}>
                                                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                    <label htmlFor="startDate" className="mb-0">Du:</label>
                                                    <input
                                                        type="date"
                                                        id="startDate"
                                                        className="form-control"
                                                        style={{ maxWidth: "150px" }}
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                    <label htmlFor="endDate" className="mb-0">Au:</label>
                                                    <input
                                                        type="date"
                                                        id="endDate"
                                                        className="form-control"
                                                        style={{ maxWidth: "150px" }}
                                                        value={endDate}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                        min={startDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <input
                                            type="text"
                                            placeholder="Rechercher..."
                                            className="form-control"
                                            style={{ maxWidth: "200px", width: "100%" }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>


                                    <div className="table-responsive">
                                        <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                            style={{ fontSize: "10px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                        onClick={() => handleSort("date_vente")}
                                                        style={{ width: "15%", minWidth: "100px" }}
                                                    >
                                                        Date
                                                        {sortConfig.key === "date_vente"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>

                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell align-middle"
                                                        onClick={() => handleSort("produit")}
                                                        style={{ width: "12%", minWidth: "80px" }}
                                                    >
                                                        Produit
                                                        {sortConfig.key === "produit"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center align-middle"
                                                        onClick={() => handleSort("mensuration_value")}
                                                        style={{ width: "10%", minWidth: "80px" }}
                                                    >
                                                        Taille
                                                        {sortConfig.key === "mensuration_value"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("prix_unitaire")}
                                                        style={{ width: "15%", minWidth: "80px" }}
                                                    >
                                                        Prix unitaire
                                                        {sortConfig.key === "prix_unitaire"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("quantite")}
                                                        style={{ width: "10%", minWidth: "70px" }}
                                                    >
                                                        Quantité
                                                        {sortConfig.key === "quantite"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("total")}
                                                        style={{ width: "12%", minWidth: "80px" }}
                                                    >
                                                        Total
                                                        {sortConfig.key === "total"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell align-middle"
                                                        onClick={() => handleSort("statut")}
                                                        style={{ width: "10%", minWidth: "150px" }}
                                                    >
                                                        Statut
                                                        {sortConfig.key === "statut"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell align-middle"
                                                        onClick={() => handleSort("client")}
                                                        style={{ width: "8%", minWidth: "150px" }}
                                                    >
                                                        Client
                                                        {sortConfig.key === "client"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell align-middle"
                                                        onClick={() => handleSort("numero_contact")}
                                                        style={{ width: "8%", minWidth: "120px" }}
                                                    >
                                                        Contact
                                                        {sortConfig.key === "numero_contact"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap  d-none d-md-table-cell align-middle"
                                                        onClick={() => handleSort("transaction_id")}
                                                        style={{ width: "5%", minWidth: "100px" }}
                                                    >
                                                        Transaction
                                                        {sortConfig.key === "transaction_id"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentVentes && currentVentes.length > 0 ? (
                                                    currentVentes.map((vente) => (
                                                        <tr
                                                            key={vente.vente_id}
                                                            onClick={() => setSelectedVente(vente)}
                                                            className={`bg-white ${selectedVente?.vente_id === vente.vente_id ? "bg-success text-white" : ""}`}
                                                        >
                                                            <td
                                                                className="d-none d-md-table-cell  align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span>{vente.date_vente ? new Date(vente.date_vente).toLocaleString() : 'N/A'}</span>
                                                            </td>

                                                            <td
                                                                className=""
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{vente.produit}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="badge bg-secondary text-white" style={{ fontSize: "10px" }}>{vente.mensuration_value}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{formatCurrency(vente.prix_unitaire)}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{vente.quantite}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{formatCurrency(vente.total)}</span>
                                                            </td>

                                                            <td className="d-none d-md-table-cell text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold badge bg-success text-white" style={{ fontSize: "10px" }}>{vente.statut}</div>
                                                            </td>
                                                            <td className="" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{vente.client}</div>
                                                            </td>
                                                            <td className="" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{vente.numero_contact}</div>
                                                            </td>
                                                            <td className="" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{vente.transaction_id}</div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9" className="text-center">
                                                            Aucune vente trouvée
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-3" style={{ position: "relative" }}>
                                        {/* Bloc gauche - Info pagination */}
                                        <div style={{ flex: 1 }}>
                                            {sortedVentes.length === 0
                                                ? "Aucun élément à afficher"
                                                : `Élément ${indexOfFirstVente + 1} à ${Math.min(indexOfLastVente, sortedVentes.length)} sur ${sortedVentes.length}`}
                                        </div>

                                        {/* Bloc centre - Chiffre d'affaire centré */}
                                        <div style={{ flex: 1, textAlign: "center", fontWeight: "bold", fontSize: "16px", color: "#000000" }}>
                                            Chiffre d'affaire: {formatCurrency(totalCA)}
                                            {searchTerm || filtreStatutAchat !== "Tout" ? (
                                                ` (Filtré: ${formatCurrency(calculateFilteredCA())})`
                                            ) : ''}
                                        </div>

                                        {/* Bloc droit - Pagination */}
                                        <div style={{ flex: 1 }} className="d-flex justify-content-end">
                                            {Array.from({ length: totalPages }, (_, index) => (
                                                <button
                                                    key={index + 1}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    className={`btn ${currentPage === index + 1 ? "btn-default" : "btn-light"} mx-1`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Ventes;